// extracted by mini-css-extract-plugin
export var searchHeader = "_95-0";
export var searchHeaderDark = "_95-1";